import { render, staticRenderFns } from "./dataMapping.vue?vue&type=template&id=6764d6af&scoped=true"
import script from "./dataMapping.vue?vue&type=script&lang=js"
export * from "./dataMapping.vue?vue&type=script&lang=js"
import style0 from "./dataMapping.vue?vue&type=style&index=0&id=6764d6af&prod&lang=scss"
import style1 from "./dataMapping.vue?vue&type=style&index=1&id=6764d6af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6764d6af",
  null
  
)

export default component.exports